import { render } from "./UiButtonClose.vue?vue&type=template&id=ae29cf92&scoped=true"
import script from "./UiButtonClose.vue?vue&type=script&lang=js"
export * from "./UiButtonClose.vue?vue&type=script&lang=js"

import "./UiButtonClose.vue?vue&type=style&index=0&id=ae29cf92&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studyflow-frontend/studyflow-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae29cf92"]])

export default __exports__